import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgX = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "socialTwitter" }, /* @__PURE__ */ React.createElement("path", { id: "exportLayerAbove", fillRule: "evenodd", clipRule: "evenodd", d: "M10.9058 7.73557C10.8696 7.73557 9.89095 6.46745 8.73189 4.9276L6.63008 2.11963H4.14856C2.78044 2.11963 1.66667 2.12887 1.66667 2.14644C1.66667 2.16492 3.11595 4.11238 4.88225 6.46745C6.64856 8.83159 8.08877 10.7968 8.07935 10.8338C8.06178 10.8606 6.61251 12.4457 4.86377 14.3388C3.10689 16.2316 1.66667 17.8084 1.66667 17.8352C1.66667 17.862 1.9837 17.8805 2.37283 17.8805H3.07066L5.83334 14.8823C7.35472 13.2341 8.64131 11.8479 8.69566 11.8026C8.76812 11.7477 9.51088 12.6631 11.096 14.7917L13.3967 17.8714L15.8692 17.8805C17.2196 17.8805 18.3333 17.8537 18.3333 17.8084C18.3333 17.7714 16.8025 15.7066 14.9366 13.2156L11.5399 8.69572L11.9743 8.23376C12.2192 7.98883 13.4511 6.65767 14.7101 5.28992C15.9692 3.92198 17.1467 2.64463 17.3279 2.45514L17.6449 2.11963H16.1685L13.5688 4.9276C12.1471 6.46745 10.942 7.73557 10.9058 7.73557ZM8.95834 10.1175C6.22247 6.4584 3.9404 3.3968 3.90435 3.3334C3.84059 3.22506 4.03117 3.20659 4.96377 3.20659H6.0866L11.1054 9.90948C13.8589 13.5964 16.1326 16.6577 16.1409 16.703C16.1594 16.7573 15.7426 16.7935 15.054 16.7935L13.9402 16.7843L8.95834 10.1175Z", fill: props.fill })));
});
export default SvgX;
